module.exports = {
    resizeImage(uriData) {
        let newImg = this.createImage(uriData);
        let naturalHeight = newImg.naturalHeight;
        let naturalWidth = newImg.naturalWidth;
        let desireRatio = 150 / 200;
        let newHeight, newWidth;

        //calculate new Size
        if (naturalWidth / naturalHeight > desireRatio) {
            //fix height
            newHeight = 400;
            newWidth = newHeight * naturalWidth / naturalHeight;
        } else {
            newWidth = 300;
            newHeight = newWidth * naturalHeight / naturalWidth;
        }

        //crop image
        let dataURI = this.cropImage(newImg, naturalWidth,naturalHeight, newWidth,newHeight);
        //convert to blob data
        return this.dataURItoBlob(dataURI);

    },
    createImage(img) {
        let createImage;
        createImage = new Image();
        createImage.src = img;
        return createImage;
    },
    cropImage(img, naturalWidth, naturalHeight, newWidth, newHeight) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext("2d");
        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, naturalWidth, naturalHeight, 0, 0, newWidth, newHeight);
        return canvas.toDataURL('image/jpeg', 0.9);
    },
    dataURItoBlob(dataURI) {
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = window.atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);
    
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
    
        return new Blob([ia], { type: mimeString });
    }
};


// WEBPACK FOOTER //
// ./app/setComponents/userSetComponents/userSetImg.js